import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18n from '../../i18n';
import { NumberFormatter } from '../../utils/Intl';

export default class ResultCount extends React.PureComponent {
    static propTypes = {
        count: PropTypes.number,
        classes: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    };

    render() {
        const count = parseInt(this.props.count, 10);
        const spanClasses = classNames('nb-results', this.props.classes);
        if (isNaN(count)) {
            return false;
        }
        return (
            <span className={spanClasses}>
                {count < 10000
                    ? i18n.t('search:layout.header.searchbar.nb_results', {
                          count,
                          count_formated: NumberFormatter.format(count)
                      })
                    : i18n.t('search:layout.header.searchbar.nb_results_above_10000')}
            </span>
        );
    }
}
